import messages from '../locales/messages';
import { FormattedMessage } from 'react-intl';
const WIDGET_ID = 'csp-carrier-interactive-tour';

export default {
  horizontalLayout: true,
  title: <FormattedMessage {...messages.widgetTitle} />,
  intro: {
    WIDGET_ID,
    active: false,
  },
  slides: {
    WIDGET_ID,
    menuLabel: <FormattedMessage {...messages.slideMenuLabel} />,
    previousLabel: <FormattedMessage {...messages.slidePreviousLabel} />,
    forwardLabel: <FormattedMessage {...messages.slideForwardLabel} />,
    restartLabel: <FormattedMessage {...messages.slideRestartLabel} />,
    nextStepsLabel: <FormattedMessage {...messages.slideNextStepsLabel} />,

    items: [
      {
        id: 'slide-1',
        title: <FormattedMessage {...messages.slide1Title} />,
        description: <FormattedMessage {...messages.slide1Description} />,
        nextSteps: {
          active: true,
          title: <FormattedMessage {...messages.slide1NextStepsTitle} />,
          location: 'slide-2',
        },
        asset: {
          WIDGET_ID,
          type: 'image',
          image: `images/screenshot-1.png`,
          imageAlt: <FormattedMessage {...messages.slide1ImageAlt} />,
          hotspot: {
            active: true,
            x: '18.5%',
            y: '10%',
            color: '#FFFFFF',
            location: 'slide-2',
          },
        },
      },
      {
        id: 'slide-2',
        title: <FormattedMessage {...messages.slide2Title} />,
        description: <FormattedMessage {...messages.slide2Description} />,
        nextSteps: {
          active: true,
          title: <FormattedMessage {...messages.slide2NextStepsTitle} />,
          location: 'slide-3',
        },
        asset: {
          WIDGET_ID,
          type: 'image',
          image: `images/screenshot-2.png`,
          imageAlt: <FormattedMessage {...messages.slide2ImageAlt} />,
          hotspot: {
            active: true,
            x: '24%',
            y: '97%',
            color: '#FFFFFF',
            location: 'slide-3',
          },
        },
      },
      {
        id: 'slide-3',
        title: <FormattedMessage {...messages.slide3Title} />,
        description: <FormattedMessage {...messages.slide3Description} />,
        nextSteps: {
          active: true,
          title: <FormattedMessage {...messages.slide3NextStepsTitle} />,
          location: 'slide-4',
        },
        asset: {
          WIDGET_ID,
          type: 'image',
          image: `images/screenshot-3.png`,
          imageAlt: <FormattedMessage {...messages.slide3ImageAlt} />,
          hotspot: {
            active: true,
            x: '13%',
            y: '15.5%',
            color: '#FFFFFF',
            location: 'slide-4',
          },
        },
      },
      {
        id: 'slide-4',
        title: <FormattedMessage {...messages.slide4Title} />,
        description: <FormattedMessage {...messages.slide4Description} />,
        nextSteps: {
          active: true,
          title: <FormattedMessage {...messages.slide4NextStepsTitle} />,
          location: 'slide-5',
        },
        asset: {
          WIDGET_ID,
          type: 'image',
          image: `images/screenshot-4.png`,
          imageAlt: <FormattedMessage {...messages.slide4ImageAlt} />,
          hotspot: {
            active: true,
            x: '18%',
            y: '15%',
            color: '#FFFFFF',
            location: 'slide-5',
          },
        },
      },
      {
        id: 'slide-5',
        title: <FormattedMessage {...messages.slide5Title} />,
        description: <FormattedMessage {...messages.slide5Description} />,
        nextSteps: {
          active: true,
          title: <FormattedMessage {...messages.slide5NextStepsTitle} />,
          location: 'slide-6',
        },
        asset: {
          WIDGET_ID,
          type: 'image',
          image: `images/screenshot-5.png`,
          imageAlt: <FormattedMessage {...messages.slide5ImageAlt} />,
          hotspot: {
            active: true,
            x: '9%',
            y: '3.5%',
            color: '#FFFFFF',
            location: 'slide-6',
          },
        },
      },
      {
        id: 'slide-6',
        title: <FormattedMessage {...messages.slide6Title} />,
        description: <FormattedMessage {...messages.slide6Description} />,
        nextSteps: {
          active: true,
          title: <FormattedMessage {...messages.slide6NextStepsTitle} />,
          location: 'slide-7',
        },
        asset: {
          WIDGET_ID,
          type: 'image',
          image: `images/screenshot-6.png`,
          imageAlt: <FormattedMessage {...messages.slide6ImageAlt} />,
          hotspot: {
            active: true,
            x: '13%',
            y: '14%',
            color: '#FFFFFF',
            location: 'slide-7',
          },
        },
      },
      {
        id: 'slide-7',
        title: <FormattedMessage {...messages.slide7Title} />,
        description: <FormattedMessage {...messages.slide7Description} />,
        nextSteps: {
          active: true,
          title: <FormattedMessage {...messages.slide7NextStepsTitle} />,
          location: 'slide-8',
        },
        asset: {
          WIDGET_ID,
          type: 'image',
          image: `images/screenshot-7.png`,
          imageAlt: <FormattedMessage {...messages.slide7ImageAlt} />,
          hotspot: {
            active: true,
            x: '17%',
            y: '13%',
            color: '#FFFFFF',
            location: 'slide-8',
          },
        },
      },
      {
        id: 'slide-8',
        title: <FormattedMessage {...messages.slide8Title} />,
        description: <FormattedMessage {...messages.slide8Description} />,
        nextSteps: {
          active: true,
          title: <FormattedMessage {...messages.slide8NextStepsTitle} />,
          location: 'slide-9',
        },
        asset: {
          WIDGET_ID,
          type: 'image',
          image: `images/screenshot-8.png`,
          imageAlt: <FormattedMessage {...messages.slide8ImageAlt} />,
          hotspot: {
            active: true,
            x: '23%',
            y: '13%',
            color: '#FFFFFF',
            location: 'slide-9',
          },
        },
      },
      {
        id: 'slide-9',
        title: <FormattedMessage {...messages.slide9Title} />,
        description: <FormattedMessage {...messages.slide9Description} />,
        nextSteps: {
          active: true,
          title: <FormattedMessage {...messages.slide9NextStepsTitle} />,
          location: 'slide-10',
        },
        asset: {
          WIDGET_ID,
          type: 'image',
          image: `images/screenshot-9.png`,
          imageAlt: <FormattedMessage {...messages.slide9ImageAlt} />,
          hotspot: {
            active: true,
            x: '28%',
            y: '13%',
            color: '#FFFFFF',
            location: 'slide-10',
          },
        },
      },
      {
        id: 'slide-10',
        title: <FormattedMessage {...messages.slide10Title} />,
        description: <FormattedMessage {...messages.slide10Description} />,
        nextSteps: {
          active: true,
          title: <FormattedMessage {...messages.slide10NextStepsTitle} />,
          location: 'slide-11',
        },
        asset: {
          WIDGET_ID,
          type: 'image',
          image: `images/screenshot-10.png`,
          imageAlt: <FormattedMessage {...messages.slide10ImageAlt} />,
          hotspot: {
            active: true,
            x: '34%',
            y: '13%',
            color: '#FFFFFF',
            location: 'slide-11',
          },
        },
      },
      {
        id: 'slide-11',
        title: <FormattedMessage {...messages.slide11Title} />,
        description: <FormattedMessage {...messages.slide11Description} />,
        nextSteps: {
          active: true,
          title: <FormattedMessage {...messages.slide11NextStepsTitle} />,
          location: 'slide-12',
        },
        asset: {
          WIDGET_ID,
          type: 'image',
          image: `images/screenshot-11.png`,
          imageAlt: <FormattedMessage {...messages.slide11ImageAlt} />,
          hotspot: {
            active: true,
            x: '2%',
            y: '3.2%',
            color: '#FFFFFF',
            location: 'slide-12',
          },
        },
      },
      {
        id: 'slide-12',
        title: <FormattedMessage {...messages.slide12Title} />,
        description: <FormattedMessage {...messages.slide12Description} />,
        nextSteps: {
          active: true,
          isLink: true,
          title: <FormattedMessage {...messages.slide12NextStepsTitle} />,
          url: 'https://www.ibm.com/account/reg/signup?formid=DEMO-automate',
        },
        asset: {
          WIDGET_ID,
          type: 'image',
          image: `images/screenshot-12.png`,
          imageAlt: <FormattedMessage {...messages.slide12ImageAlt} />,
        },
      },
    ],
  },
};
